import Dialog from './dialog';
import Analytics from "./analytics";

class Login extends Dialog {

    constructor(el = {}) {
        const dialog = super({
            containerElement: el,
            dialogElement: el.querySelector('.login'),
            btnOpenElement: document.querySelectorAll('.button__openLogin'),
            btnCloseElement: el.querySelector('.login__closeButton')
        });

        this.dialog = dialog;
        this.login = this.login.bind(this);
        this.reset = this.reset.bind(this);

        this.createAccountBtn = this.dialog.containerElement.querySelector('.button-new--secondary');
        this.loginBtn = this.dialog.containerElement.querySelector('.login__button');
        if (this.loginBtn) {
            this.loginBtn.addEventListener('click', this.login);
        }
        addEventListener('dialog-closed', this.reset);

        this.message = this.containerElement.querySelector('.login__message');
        this.noWebUserMessage = this.containerElement.querySelector('.login__no-web-user');
        this.defaultLoginBtnText = 'Logga in';
        this.defaultMessage = this.containerElement.querySelector('.login__message').textContent;
        this.defaultNoWebUserMessage = this.containerElement.querySelector('.login__no-web-user').textContent;
    }

    login(e) {
        e.preventDefault();

        this.message.style.display = 'none';
        this.noWebUserMessage.style.display = 'none';
        this.loginBtn.style.display = 'none';
        if (this.createAccountBtn) {
            this.createAccountBtn.style.display = 'none';
        }

        if (!this.dialog.containerElement.querySelector('.login__form').reportValidity()) {
            this.loginBtn.style = null;
            return;
        }

        this.dialog.dialogElement.classList.add('loading');
        const loadingDots = document.createElement("div");
        loadingDots.classList.add("login__loading-dots", "loading-dots");
        for (let i = 0; i < 4; i++) {
            const child = document.createElement("div");
            loadingDots.appendChild(child);
        }

        this.dialog.dialogElement.appendChild(loadingDots);

        fetch(this.dialog.containerElement.querySelector('.login__form').getAttribute('action'), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' //Ugly fix for IsAjaxRequest()
            },
            body: JSON.stringify({
                username: this.dialog.dialogElement.querySelector('#login-username').value,
                password: this.dialog.dialogElement.querySelector('#login-password').value,
            })
        }).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response;
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }).then((response) => {
            return response.json();
        }).then((json) => {
            if (json.status === 200) {
                window.location = json.redirectUrl;

                dataLayer.push({
                    'event': 'login',
                    'logedinStatus': 'Login',   // Login|Logout
                    'selectedBranch': Analytics.formatBranchName(json.branch)
                });
            } else {
                if (json.noWebUserFound) {
                    this.noWebUserMessage.style.display = 'block';
                }
                else {
                    this.message.style.display = 'block';
                }

                this.dialog.dialogElement.classList.remove('loading');
                this.dialog.dialogElement.querySelector('.login__loading-dots').remove();
                this.loginBtn.style = null;
                if (this.createAccountBtn) {
                    this.createAccountBtn.style = null;
                }
            }

        }).catch((ex) => {
            console.log(ex);
        });
    }

    reset() {
        this.message.innerHTML = `<p>${this.defaultMessage}</p>`;
        this.message.style.color = '#FF4040';
        this.message.style.display = 'none';

        this.noWebUserMessage.innerHTML = `<p>${this.defaultNoWebUserMessage}</p>`;
        this.noWebUserMessage.style.color = '#FF4040';
        this.noWebUserMessage.style.display = 'none';

        this.dialog.dialogElement.querySelector('#login-password').removeAttribute('disabled');
        this.loginBtn.addEventListener('click', this.login);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (!window.authenticated) {
        new Login(document.getElementById('login'));
        const inlineDialog = document.getElementById('login-inline');
        if (inlineDialog) {
            new Login(inlineDialog);
        }
    }
});
